import React from 'react';
import { Switch as AntSwitch } from 'antd';

const Switch = ({ checked, onChange, disabled = false, activeColor = '#8149f9', ...props }) => {
  return (
    <AntSwitch
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      style={{
        backgroundColor: checked ? activeColor : undefined,
        borderColor: checked ? activeColor : undefined,
      }}
      {...props}
    />
  );
};

export default Switch;
